/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Service, { inject as service } from '@ember/service';
import type ModalService from 'embercom/services/modal-service';
import type SyncSourceWrapper from 'embercom/models/knowledge-hub/sync-source-wrapper';

export default class ContentImportLogsModalService extends Service {
  @service declare modalService: ModalService;
  @service declare appService: $TSFixMe;

  openContentImportLogsSheet(syncSource: SyncSourceWrapper) {
    this.modalService.openModal('react/knowledge-hub/content-import-logs-sheet', {
      appId: this.appService.app.id,
      sourceId: syncSource.sourceId,
      sourceType: syncSource.sourceType,
      onOpenChange: () => {
        this.modalService.closeModal();
      },
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    'content-import-logs-modal-service': ContentImportLogsModalService;
  }
}
